module.exports = "/static/fonts/OpenSans-LightItalic.woff";